import React from "react";
import classnames from "classnames";
import { YearInReviewButton } from "@ugitgud/legos/ui/form/button/YearInReviewButton";
import { SvgYearInReviewLogoFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewLogoFull";
import { AppRoutes } from "@ugg/shared/routes/app-routes";

interface YearInReviewCtaProps {
  className?: string;
  utmSource: string;
  onClick?: (url: string) => void;
}

export default function YearInReviewCta(props: YearInReviewCtaProps) {
  const { className, utmSource, onClick } = props;
  const classNames = classnames(className);

  const href = utmSource ? `${AppRoutes.YEAR_IN_REVIEW}?utm_source=${utmSource}` : AppRoutes.YEAR_IN_REVIEW;
  const onUrlClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault();
      onClick(href);
    }
  };

  return (
    <div className={classNames}>
      <div className="year-in-review-cta">
        <div className="w-full h-[120px] bg-[#11173D] items-center flex relative overflow-hidden border border-[#F4C874] rounded pl-6">
          <div className="relative h-[120px] w-full shrink-0 bg-no-repeat [background-image:linear-gradient(to_left,transparent,70%,#11173D_100%),url('https://static.bigbrain.gg/assets/ugg/cta/year-in-review-banner.png')] [background-position:165%_0.5%] [background-size:82.5%_auto]" />
          <div className="absolute inset-0 z-10 flex items-center justify-start gap-6   px-6 text-white">
            <SvgYearInReviewLogoFull className="w-[72px] h-[72px]" />
            <div className="flex flex-col">
              <div className="relative -top-0.5 uppercase font-barlow font-semibold text-[18px] leading-[18px] text-center xs:text-left whitespace-nowrap mb-[2px]">
                <span className="hidden xxs:inline">YEAR IN REVIEW</span>
              </div>
              <div className="font-inter font-medium text-[12px] leading-[12px] hidden xs:block text-center sm:text-left text-[#CDDCFE] mb-2">
                A personally curated summary of your 2025 stats
              </div>
              <YearInReviewButton
                href={`${href}?utm_source=uggbuildcta`}
                onClick={onUrlClick}
                className=" h-[30px] w-fit px-[12px] py-[10px] space-x-2 sm:space-x-3 flex items-center"
              >
                <div className="text-[12px] sm:text-[13px] font-bold whitespace-nowrap">Generate Yours Now</div>
              </YearInReviewButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
